export function shopUrl(code, name) {
	let slug = (name || '').toLowerCase();
	slug = slug.replace(/[^0-9a-z ]/g, '');
	slug = slug.trim().replace(/ +/g, '-').replace(/-+$/, '');
	return `https://www.afi-usa.com/shop/fragrance-oils/${code || ''}/${encodeURIComponent(slug)}`;
}
